import { useEffect, useRef, useState } from 'react'
import { Edge, NodeProps } from 'reactflow'

import { convertBytesToText } from '@ui/lib/utils'
import clsx from 'clsx'

interface NodeOutputSizeProps {
  node: NodeProps
  edges: Edge[]
}

export const NodeOutputSize = ({ node, edges }: NodeOutputSizeProps) => {
  const nodeContainerRef = useRef<HTMLDivElement>(null)

  const [outputSize, setOutputSize] = useState<number | null>(null)

  const outboundEdgeCount = edges.filter((edge) => edge.source == node.id).length

  useEffect(() => {
    const outputSizeData = node.data.size

    if (outputSizeData) {
      setOutputSize(outputSizeData.span + outputSizeData.log + outputSizeData.metric)
    }
  }, [node.data.size])

  const getOutputSizeDisplay = () => {
    if (node.type == 'export') {
      return <></>
    }
    let offset = 'right-1.5'
    if (convertBytesToText(outputSize, false).length > 3) {
      offset = 'right-0.5'
    }
    if (outboundEdgeCount > 3 && node.type == 'firehose') {
      return (
        <div className={clsx('absolute top-[20px] mx-auto text-center text-3xs text-gray-700', offset)}>
          <div className={'relative'}>
            <div>{convertBytesToText(outputSize)}</div>
            <div>/min</div>
          </div>
        </div>
      )
    } else if (outboundEdgeCount > 3) {
      return (
        <div className={clsx('absolute top-[20px] text-center text-3xs text-gray-700', offset)}>
          <div>{convertBytesToText(outputSize)}</div>
          <div>/min</div>
        </div>
      )
    }
    return (
      <div className="absolute -right-6 top-[34px] text-3xs text-gray-700">{convertBytesToText(outputSize)}/min</div>
    )
  }

  return (
    <>
      <div className={clsx('absolute -right-10 top-12 z-0 h-full w-[147%]')} ref={nodeContainerRef}>
        {getOutputSizeDisplay()}
      </div>
    </>
  )
}
